<template>
  <div class="gauge-widget">
    <k-gauge v-bind="opts" :title="''" />
  </div>
</template>

<script>

import KGauge from "@kagronick/kgauge-vue";

import { get } from 'lodash';

export default {
  name: 'Gauge',
  components: {
    KGauge
  },
  props: ["appdata", "options", "loading"],

  watch: {
    "appdata.response": function(val) {
      if(Object.keys(val).length == 0) {
        return
      } else {
        this.opts = {...{
          "value": this.ld.get(val, this.options.module, []).value || 0,
          "title": "",
          valueFontStyle: "fill: white; font-size: 2.5em",
          labelFontStyle: "fill: white; font-size: 1.5em",        
          doughnut: true,
          showMinMax: false,
          gaugeSize: 0.5
        }, ...this.opts}
      }
    }
  },

  methods: {

  },

  data() {
    return {
      opts: {...{
        "titleStyle": "fill: white",
        "title": "",
        valueFontStyle: "fill: white; font-size: 2.5em",
        labelFontStyle: "fill: white; font-size: 1.5em",
        doughnut: true,
        showMinMax: false,
        gaugeSize: 0.5,
      }, ...this.options},
      ld: {
        get: _.get
      }
    }
  }
}
</script>

<style scoped>
  svg {
    display: block;
    margin: 0 auto;
    width: 99%;
    height: 99%;
  }
</style>
